import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-269b7b53"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "WargingMessage" }, null, -1))
const _hoisted_2 = { class: "WargingMessage_Content" }
const _hoisted_3 = { class: "WargingMessage_Main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold",
  style: {"white-space":"pre-wrap"}
}, [
  /*#__PURE__*/_createTextVNode(" このレコードは編集中に他ユーザーによって更新されました。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 再度やり直してください。 ")
], -1))
const _hoisted_5 = { class: "WargingMessage_BtnBlock" }

import { ref, reactive, computed, watch } from "vue";
import BtnGreen from "../atoms/button/BtnGreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalExclusion',
  emits: ["confirm"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const execute = () => {
  emit("confirm");
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'exclamation-triangle'],
          class: "icon__save__filed"
        }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BtnGreen, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (execute()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("OK")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})